import { makeAutoObservable } from "mobx";

export class NumberListModel {
    IdList: number[];
    constructor() {
        makeAutoObservable(this);
        this.IdList = [];
    }
}